/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SSOImageLangRepositoryResponse } from "../types/SSOImageLangRepositoryResponse.ts";

export const SSOImageLangRepositoryResponseSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID da variação de idioma da imagem SSO."),
  ),
  cultureInfo: z
    .string()
    .describe("Código de cultura do idioma da variação (ex: pt-BR, en-US).")
    .nullish(),
  urlStorage: z
    .string()
    .describe(
      "URL de armazenamento do arquivo de imagem SSO para este idioma/viewport.",
    )
    .nullish(),
}) as unknown as ToZod<SSOImageLangRepositoryResponse>;
